import { Component } from "@angular/core";
import { AmazonService } from "../../../services/amazon.service";
import { PaginationInstance } from "ngx-pagination";
import { ActivatedRoute } from "@angular/router";
import { Seller } from "../../../objects/amazon/seller";
import { LocationSearchRequest } from "../../../objects/requests/locationSearchRequest";


@Component({
    selector: "amazon-seller-management",
    templateUrl: 'amazon-seller-management.component.html',
    moduleId: module.id.toString()
})
export class AmazonSellerManagementComponent {
    public idToBlur: string = "customer-management";

    public sellers: Array<Seller> = [];

    public config: PaginationInstance = {
        id: 'custom',
        itemsPerPage: 12,
        currentPage: 1,
        totalItems: 1
    };

    constructor(private route: ActivatedRoute, public amazonService: AmazonService) {

    }

    public ngOnInit(): void {
        this.sellers = this.route.snapshot.data.sellers.Items;
        this.config.totalItems = this.route.snapshot.data.sellers.TotalCount;
    }

    public search(): void {
        this.amazonService.getSellers(
            (this.config.currentPage - 1) * this.config.itemsPerPage,
            this.config.itemsPerPage
        ).then((response) => {
            this.sellers = response.Data.Items;
        });
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/amazon-management/amazon-seller-management.component.ts